export class Config {
  public static readonly ARC_GIS_API: string = 'https://js.arcgis.com/4.6/';
  public static readonly ARC_GIS_LOCATOR: string = 'http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer';
  public static readonly ARC_GIS_LOCATOR_TOLERANCE: number = 80;
}
